import React from 'react'
import AccessTimeIcon from '@mui/icons-material/AccessTime'

import styles from './styles'
import BuildBGCScoreBoard from './BuildBGCScoreBoard'
import ExpandableBackgroundCheck from './ExpandableBackgroundCheck'

const ExpandedInfo = (props) => {
  const { applicationData } = props
  const classes = styles()

  return (
    <div className={classes.root}>
      {applicationData ? (
        <div className={classes.content}>
          <section className={classes.section}>
            <div className={classes.sectionTitle}>
              {applicationData.background_check?.status === 'PROCESSING' && (
                <AccessTimeIcon style={{ color: '#FFF' }} />
              )}
              Background Check
            </div>

            {applicationData?.score_board && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                }}
              >
                <BuildBGCScoreBoard scoreBoardData={applicationData.score_board} />
              </div>
            )}

            {applicationData.background_check && (
              <div className={classes.bgc}>
                <ExpandableBackgroundCheck backgroundCheck={applicationData?.background_check} />
              </div>
            )}
          </section>
        </div>
      ) : (
        <div className={classes.notFound}>Nenhuma informação encontrada.</div>
      )}
    </div>
  )
}

export default ExpandedInfo
